// extracted by mini-css-extract-plugin
export default {"div":"contacts_div__pEIuX"};